import loadable from '@loadable/component';

export const loadCashoutModule = /* #__LOADABLE__ */ () =>
    import(/* webpackChunkName: "cashout-module" */ './index');

export const AsyncCashOut = loadable(loadCashoutModule, {
    resolveComponent: ({ default: cashout }) => cashout.components.CashOut,
});
